module.exports = __webpack_public_path__ + "static/media/partner-9.1907afcf.jpeg";